import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const HealthPlusIllustration = ({ width = 40, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#6AB3A9"
          d="M40 20c0 11.048-8.954 20-20 20C8.957 40 0 31.048 0 20 0 8.953 8.957 0 20 0c11.046 0 20 8.953 20 20"
        />
        <path
          fill="#FFF"
          d="M16.995 9.176L23.005 9.176 23.005 17.003 30.819 17.003 30.819 22.996 23.005 22.996 23.005 30.823 16.995 30.823 16.995 22.996 9.181 22.996 9.181 17.003 16.995 17.003z"
        />
        <path fill="#000" fillOpacity=".1" d="M20 40V0c11.046 0 20 8.953 20 20 0 11.048-8.954 20-20 20" />
      </g>
    </svg>
  </DefaultIconWrapper>
);
